<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-09 16:21:02
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-04-09 14:59:16
 * @FilePath: \hzs-nutra-wecom-shop\src\views\BuyerProxyPayment\BuyerProxyPayment.vue
 * @Description: 代客下单
-->

<template>
  <div class="page-container">
    <div class="mainContent">
      <div class="searchBox flex align-center justify-sb">
        <van-icon name="search" color="#B3B3B3" size="24" />

        <input
          type="text"
          v-model="state.query_condition"
          class="flex-1"
          placeholder="请输入客户名称或手机号搜索"
          @update:model-value="handleSearch"
        />
      </div>

      <!-- <van-pull-refresh
        v-if="state.listData.length"
        v-model="state.isRefresh"
        pull-distance="80"
        @refresh="onRefresh"
      >
        <van-list
          v-model:loading="state.listLoading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in state.listData"
            :key="item.id"
            class="customerItem rel"
            @click="handleSelectCustomer(item)"
          >
            <div class="up flex align-center">
              <img
                :src="item?.user?.wx_user?.avatar_url || EmptyHeadImg"
                class="img"
                alt=""
              />

              <div class="msg">
                <div class="name">{{ item?.user?.name }}</div>
                <div class="gOrA">
                  {{ getGender(item?.user?.sex) }}
                  {{ getAge(item?.user?.birthday) }}岁
                </div>
              </div>
            </div>

            <div class="down">
              <div class="phone">手机号码：{{ item?.user?.phone }}</div>
              <div class="phone">归属门店：{{ item?.shop?.name }}</div>
            </div>

            <img
              v-show="state.selectedId === item.user_uuid"
              src="@/assets/img/icons/selected.png"
              alt=""
              class="abs selectedImg"
            />
          </div>
        </van-list>
      </van-pull-refresh>
      <div v-else class="emptyBox flex align-center justify-sc">
        <van-empty
          :image="emptyCustomerImg"
          image-size="150"
          description="没有该客户？去创建新客户"
        />
      </div> -->

      <div class="pageList">
        <PullAndPush_list
          v-if="isDataReady"
          ref="listRef"
          :request="CustomerApi._customerList"
          :otherParams="otherParams"
          @loaded="onLoaded"
        >
          <template #default="{ list }">
            <div
              v-for="item in list"
              :key="item.id"
              class="customerItem rel"
              @click="handleSelectCustomer(item)"
            >
              <div class="up flex align-center">
                <img
                  :src="item?.user?.wx_user?.avatar_url || EmptyHeadImg"
                  class="img"
                  alt=""
                />

                <div class="msg">
                  <div class="name">{{ item?.user?.name }}</div>
                  <div class="gOrA">
                    {{ getGender(item?.user?.sex) }}
                    {{ getAge(item?.user?.birthday) }}岁
                  </div>
                </div>
              </div>

              <div class="down">
                <div class="phone">手机号码：{{ item?.user?.phone }}</div>
                <div class="phone">归属门店：{{ item?.shop?.name }}</div>
              </div>

              <img
                v-show="state.selectedId === item.user_uuid"
                src="@/assets/img/icons/selected.png"
                alt=""
                class="abs selectedImg"
              />
            </div>
          </template>
        </PullAndPush_list>
      </div>
    </div>

    <div class="bottom_button_box">
      <button class="btn btn-default" @click="handleCreateCustomer">
        去创建客户
      </button>
      <button
        v-if="state.listData.length"
        class="btn btn-primary"
        @click="handleTakeOrder"
      >
        去下单
      </button>
    </div>

    <div class="safe-area-placeholder"></div>
  </div>
</template>

<script lang="ts" setup>
import PullAndPush_list from "@/components/PullAndPush_list/index.vue";
import dayjs from "dayjs";
import {
  ref,
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import CustomerApi from "@/utils/api/customer";
import emptyCustomerImg from "@/assets/img/customer/emptyCustomer.png";
import EmptyHeadImg from "@/assets/img/icons/emptyHeadImg.png";
import { showFailToast } from "vant";

// --------------------------------------- 变量
let shop_clerk_uuid: string | undefined | null = undefined;
let shop_uuid: string | undefined | null = undefined;
let isDataReady = ref(false);
const router = useRouter();
const state = reactive({
  query_condition: undefined,

  listData: [] as any[],

  pagination: {
    page: 1,
    lastPage: 1,
    pageSize: 10,
    lastPageSize: 1,
    total: 0,
  },

  isRefresh: false,
  finished: true,
  listLoading: false,

  selectedId: undefined,
});
const otherParams = computed(() => ({
  shop_clerk_uuid: shop_clerk_uuid,
  // shop_uuid: shop_uuid,
  query_condition: state.query_condition,
  page: state.pagination.page,
  page_size: state.pagination.pageSize,
}));
const listRef = ref<any>(null);
// --------------------------------------- 方法、事件
const getGender = (gender: number | string) =>
  ({
    1: "男",
    2: "女",
    3: "",
  })[gender] || "";
function getAge(birthday) {
  return dayjs().diff(dayjs(birthday), "year");
}

onMounted(async () => {
  shop_clerk_uuid = localStorage.getItem("shop_clerk_uuid");
  shop_uuid =
    JSON.parse(localStorage.getItem("departmentdata") as string)
      ?.department_uuid || undefined;

  await nextTick();
  isDataReady.value = true;
  //   await getData();
});

function onLoaded(payload: { page: number; list: any[] }) {
  state.listData = payload.list;
}

// // 下拉刷新 -回调
// const onRefresh = async () => {
//   // 重置列表状态
//   state.isRefresh = true;
//
//   state.listData = [];
//
//   state.pagination.lastPage = state.pagination.page;
//   state.pagination.lastPageSize = state.pagination.pageSize;
//
//   state.pagination.page = 1;
//   state.pagination.pageSize =
//     state.pagination.lastPage * state.pagination.lastPageSize;
//
//   //   await getData();
// //   listRef.value?.reloadCurrentPage();
//   await nextTick();
//   state.isRefresh = false;
//   state.pagination.pageSize = state.pagination.lastPageSize;
// };
//
// // 上拉加载 -回调 (由 van-list 触发)
// const onLoad = async () => {
//   if (state.listData.length < state.pagination.total) {
//     state.pagination.page += 1;
//     // await getData();
// //     listRef.value?.reloadCurrentPage();
//   }
// };

let timer_: any = null; // 定时器引用
function handleSearch() {
  // 防抖处理：用户停止输入 500ms 后再请求
  if (timer_) clearTimeout(timer_);
  timer_ = setTimeout(async () => {
    // getData();
    listRef.value?.reloadCurrentPage();
  }, 1000); // 1000毫秒延迟
}

// 选择客户
function handleSelectCustomer(item) {
  if (state.selectedId === item.user_uuid) {
    state.selectedId = undefined;
  } else {
    state.selectedId = item.user_uuid;
  }
}
// 去下单
function handleTakeOrder() {
  if (!state.selectedId) {
    showFailToast("请点击选择客户！");
    return;
  }

  router.push({
    path: "/takeOrderType",
    query: {
      user_uuid: state.selectedId,
    },
  });
}

// 创建客户
function handleCreateCustomer() {
  router.push("/createCustomer");
}

// --------------------------------------- 请求
const getData = async () => {
  const params = {
    shop_clerk_uuid: shop_clerk_uuid,
    // shop_uuid: shop_uuid,
    query_condition: state.query_condition,
    page: state.pagination.page,
    page_size: state.pagination.pageSize,
  };
  let res = await CustomerApi._customerList(params).catch(() => {
    state.listLoading = false;
  });
  if (res?.code === 200) {
    const newData = res?.data || [];
    const total = res?.total || res?.cnt || 0;

    state.pagination.total = total;

    // 累加数据逻辑
    if (state.pagination.page === 1) {
      // 第一页直接覆盖 (刷新场景)
      state.listData = newData;
    } else {
      // 非第一页追加 (上拉场景)
      state.listData = [...state.listData, ...newData];
    }

    // 【关键判断】是否设置 finished
    if (state.listData.length >= state.pagination.total) {
      state.finished = true;
    } else {
      state.finished = false;
    }
  }
  let timer: any = setTimeout(() => {
    state.listLoading = false;

    clearTimeout(timer);
    timer = null;
  }, 500);
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.searchBox {
  height: 45px;
  padding: 11px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;

  input {
    flex: 1;
    width: calc(100% - 24px - 8px);
    height: 100%;
    border: none;
    outline: none;

    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
  /* WebKit browsers */
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
  /* Mozilla Firefox 4 to 18 */
  input:-moz-placeholder,
  textarea:-moz-placeholder {
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
  /* Mozilla Firefox 19+ */
  input::-moz-placeholder,
  textarea::-moz-placeholder {
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
  /* Internet Explorer 10+ */
  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
}

.emptyBox,
.pageList,
.van-pull-refresh {
  height: calc(100% - 45px - 10px);
  margin-top: 10px;
  overflow-y: scroll;

  .customerItem {
    padding: 6px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }

    .up {
      padding: 11px 10px;
      border-bottom: 1px solid #f2f2f2;

      .img {
        width: 42px;
        height: 42px;
        border-radius: 100%;

        margin-right: 11px;
      }

      .name {
        height: 25px;
        line-height: 25px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .gOrA {
        height: 20px;
        line-height: 20px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
    .down {
      padding: 12px 10px 6px;

      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;

      div {
        height: 20px;
        line-height: 20px;
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
    .selectedImg {
      width: 16px;
      height: 16px;
      top: 16px;
      right: 16px;
    }
  }
}
</style>
